import { render, staticRenderFns } from "./instructionForm.vue?vue&type=template&id=31aa722f&scoped=true&"
import script from "./instructionForm.vue?vue&type=script&lang=js&"
export * from "./instructionForm.vue?vue&type=script&lang=js&"
import style0 from "./instructionForm.vue?vue&type=style&index=0&id=31aa722f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa722f",
  null
  
)

export default component.exports